import ReactPaginate, { type ReactPaginateProps } from "react-paginate";
import { useLocale } from "hooks";
import type { FC } from "react";

interface IProps {
  handlePageClick: ReactPaginateProps["onPageChange"];
  currentPage: number;
  totalPagesCount: number;
}

const Pagination: FC<IProps> = ({
  currentPage,
  totalPagesCount,
  handlePageClick,
}) => {
  const { isRTL } = useLocale();
  return (
    <ReactPaginate
      previousLabel={
        !isRTL ? (
          <svg
            width="5"
            height="9"
            viewBox="0 0 5 9"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5 1.60046L1.90701 4.69346L5 7.78645L4.04313 8.73658L-1.76731e-07 4.69346L4.04313 0.65033L5 1.60046Z"
              fill="#344456"
            />
          </svg>
        ) : (
          <svg
            width="7"
            height="10"
            viewBox="0 0 7 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.148438 1.175L3.97344 5L0.148438 8.825L1.33177 10L6.33177 5L1.33177 -5.17252e-08L0.148438 1.175Z"
              fill="#344456"
              fillOpacity="0.6"
            />
          </svg>
        )
      }
      nextLabel={
        !isRTL ? (
          <svg
            width="7"
            height="10"
            viewBox="0 0 7 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.148438 1.175L3.97344 5L0.148438 8.825L1.33177 10L6.33177 5L1.33177 -5.17252e-08L0.148438 1.175Z"
              fill="#344456"
              fillOpacity="0.6"
            />
          </svg>
        ) : (
          <svg
            width="5"
            height="9"
            viewBox="0 0 5 9"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5 1.60046L1.90701 4.69346L5 7.78645L4.04313 8.73658L-1.76731e-07 4.69346L4.04313 0.65033L5 1.60046Z"
              fill="#344456"
            />
          </svg>
        )
      }
      breakLabel="..."
      forcePage={currentPage - 1}
      pageCount={totalPagesCount}
      marginPagesDisplayed={2}
      onPageChange={handlePageClick}
      containerClassName="tw-flex tw-justify-center tw-list-none tw-items-center"
      subContainerClassName="pagination__pagination-container"
      pageLinkClassName="tw-text-[#344456]/40 hover:tw-text-[#344456] tw-border tw-border-r-0 tw-border-solid tw-border-[#E5E9F4] tw-px-4 tw-py-2 tw-cursor-pointer"
      activeLinkClassName="!tw-text-[#344456]"
      breakClassName="pagination__break"
      {...{
        [isRTL ? "nextLinkClassName" : "previousLinkClassName"]:
          "tw-border tw-border-r-0 tw-border-solid tw-border-[#E5E9F4] tw-rounded-l-xl tw-px-4 tw-py-2 tw-cursor-pointer tw-text-[#344456]/40 hover:tw-text-[#344456]",
        [isRTL ? "previousLinkClassName" : "nextLinkClassName"]:
          "tw-border tw-border-solid tw-border-[#E5E9F4] tw-rounded-r-xl tw-px-4 tw-py-2 tw-cursor-pointer tw-text-[#344456]/40 hover:tw-text-[#344456]",
      }}
    />
  );
};

export default Pagination;
